import script from "./PoliticasCancelacion.vue?vue&type=script&setup=true&lang=js"
export * from "./PoliticasCancelacion.vue?vue&type=script&setup=true&lang=js"

import "./PoliticasCancelacion.vue?vue&type=style&index=0&id=60b276b4&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60b276b4"]])

export default __exports__